<template>
  <b-row>
    <b-col
      cols="12"
      class="mb-1"
    >
      <div class="font-weight-bolder font-medium-2">
        Fotoğraf Yükle
      </div>
    </b-col>
    <b-col
      v-for="(photo,index) in workItem.photos"
      :key="index"
      cols="12"
      md="4"
      class="mb-1"
    >
      <photo-item
        :data-item="photo"
        :item-index="index"
        :remove-photo="removePhoto"
      />
    </b-col>
    <b-col
      cols="12"
      class="mt-1"
    >
      <b-alert
        variant="danger"
        show
      >
        <div class="alert-body text-center">
          Fotoğraf yükleme alanına en az 3 fotoğraf yükleyin.
        </div>
      </b-alert>
    </b-col>
    <b-col
      cols="12"
      class="text-center mt-1"
    >
      <b-button
        variant="primary"
        pill
        @click="addPhoto"
      >
        <FeatherIcon icon="PlusIcon" />
        Daha fazla fotoğraf yükle
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BAlert, BButton,
} from 'bootstrap-vue'
import PhotoItem from '@/views/Services/View/ServiceWorkForm/UploadPhotos/PhotoItem.vue'

export default {
  name: 'UploadPhotos',
  components: {
    BRow,
    BCol,
    BAlert,
    BButton,
    PhotoItem,
  },
  computed: {
    workItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
  },
  methods: {
    addPhoto() {
      this.workItem.photos.push({
        id: null, photo: null, thumb: null, id_service_works: null,
      })
    },
    removePhoto(index) {
      if (index > 2) {
        const { id } = this.workItem.photos[index]
        if (id) {
          // Remove Database
          this.removeImage(id, index)
        } else {
          this.workItem.photos.splice(index, 1)
        }
      } else {
        const { id } = this.workItem.photos[index]
        if (id) {
          // Remove Database
          this.removeImage(id, index)
        }
      }
    },
    removeImage(id, index) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('cropperUploads/removeData', { id })
            .then(response => {
              if (response.status) {
                if (index > 2) {
                  this.workItem.photos.splice(index, 1)
                } else {
                  this.workItem.photos[index].id = null
                  this.workItem.photos[index].photo = null
                  this.workItem.photos[index].thumb = null
                  this.workItem.photos[index].id_service_works = null
                }
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
